export default "__VITE_ASSET__Q3YqCjWs__"